import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-company-driver-edit-modal',
  templateUrl: './company-driver-edit-modal.component.html',
  styleUrls: ['./company-driver-edit-modal.component.css']
})
export class CompanyDriverEditModalComponent implements OnInit {
  @Input() driver: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveDriver(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}